import { Link, useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';

/** Catch-all: a wrong URL should say so, not quietly render Projects. */
export function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-8 text-center">
      <Compass className="h-10 w-10 text-graphite-500" aria-hidden />
      <h1 className="text-xl font-semibold text-graphite-100">Page not found</h1>
      <p className="max-w-md text-sm text-graphite-400">
        Nothing lives at <code className="rounded bg-graphite-800 px-1.5 py-0.5 text-graphite-300">{pathname}</code>.
        If a link brought you here, tell the office — otherwise head back to somewhere real.
      </p>
      <Link to="/today" className="mt-2 text-sm text-safety-400 hover:underline">Back to Today</Link>
    </div>
  );
}
